import React, { useContext, useState } from 'react';

import { FormControl, RadioGroup, FormControlLabel, Radio, Box, Typography, TextField, InputAdornment } from '@mui/material';
import moment from 'moment';
import LocalizedDatePicker from '../../../../../../custom-widgets/LocalizedDatePicker';
import sx, { RecurringCard } from '../RecurringItem.style';
import { Schedule } from '@mui/icons-material';
import SchedulingContext from '../../../../SchedulingContext';

function EndDateRadioCard({ item, setItem, disabled }) {
    const { properties } = useContext(SchedulingContext);

    const [radioSelection, setRadioSelection] = useState('After');
    const pluralChar = item.numberOccurrences > 1 ? 's' : '';

    const handleRadioSelection = (event) => {
        setRadioSelection(event.target.value);

        if (event.target.value === 'On') {
            setItem((i) => ({
                ...i,
                numberOccurrences: null,
            }));
        } else if (event.target.value === 'After') {
            setItem((i) => ({
                ...i,
                numberOccurrences: properties.recurringItemDefaults?.defaultOccurrences,
            }));
        }
    };

    const handleEndDate = (date) => {
        setItem({
            ...item,
            recurEndDate: date,
            numberOccurrences: null,
        });
    };

    const handleNumberRecurrences = (event) => {
        setItem({
            ...item,
            numberOccurrences: Math.min(Math.max(1, Number(event.target.value)), 50000),
            recurEndDate: null,
        });
    };

    const activeStyling = (active) => (theme) => ({
        backgroundColor: radioSelection === active ? `${theme.palette.primary.light}3F` : 'none',
        border: radioSelection === active ? `1px solid ${theme.palette.primary.main}3E` : 'none',
        color: radioSelection === active ? theme.palette.primary.dark : 'black',
    });

    return (
        <RecurringCard title={'Ends'}>
            <FormControl sx={(theme) => sx(theme).formControl}>
                <RadioGroup value={radioSelection} onChange={handleRadioSelection}>
                    <FormControlLabel
                        value="On"
                        control={<Radio />}
                        disabled={disabled}
                        fullWidth
                        sx={(theme) => ({ backgroundColor: activeStyling('On'), ...sx(theme).radioButton })}
                        label={
                            <Box fullWidth display="flex" flexDirection="column">
                                <Typography sx={(theme) => sx(theme).marginR}>On</Typography>
                                {item.numberOccurrences == null && (
                                    <LocalizedDatePicker
                                        size="small"
                                        inputVariant="outlined"
                                        format="DD MMM YYYY"
                                        value={item.recurEndDate}
                                        onChange={handleEndDate}
                                        sx={{ backgroundColor: 'white' }}
                                        disabled={radioSelection !== 'On'}
                                        // wrap
                                    />
                                )}
                            </Box>
                        }
                    />
                    <FormControlLabel
                        value="After"
                        control={<Radio />}
                        disabled={disabled}
                        sx={(theme) => ({ ...activeStyling('After')(theme), ...sx(theme).radioButton })}
                        label={
                            <Box display="flex" flexDirection="column">
                                After
                                {item.numberOccurrences >= 1 && (
                                    <TextField
                                        placeholder="#"
                                        sx={{ backgroundColor: 'white' }}
                                        type="number"
                                        value={item.numberOccurrences || 1}
                                        onChange={handleNumberRecurrences}
                                        InputProps={{
                                            endAdornment: <InputAdornment sx={{ backgroundColor: 'white' }} position="end">{`occurrence${pluralChar}`}</InputAdornment>,
                                        }}
                                        disabled={radioSelection !== 'After'}
                                    />
                                )}
                            </Box>
                        }
                    />
                </RadioGroup>
            </FormControl>
        </RecurringCard>
    );
}

export default EndDateRadioCard;
